(function () {
    'use strict';

    angular
        .module('app')
        .factory('adminOptionsFactory', adminOptionsFactory);

    adminOptionsFactory.$inject = ['$http', '$q'];

    function adminOptionsFactory($http, $q) {
        var service = {
            getAdminOptions: getAdminOptions,
            postAdminOptions: postAdminOptions,
            testUploadFolder: testUploadFolder
        };

        return service;

        function getAdminOptions() {
            var promise = $http.get('../Synergis.WebApi/api/AdminOptions/GetUploadOptions');
            return promise;
        }

        function testUploadFolder(adminOptions) {
            var deferred = $q.defer();

            //Makes http request
            var request = $http({
                method: 'POST',
                url: '../Synergis.WebApi/api/AdminOptions/TestUploadFolder',
                data: adminOptions,
            }).then(function (response, status, headers, cfg) {
                deferred.resolve(response);
            }, function (err, status) {
                deferred.reject(err);
            });

            return deferred.promise;
        }



        function postAdminOptions(adminOptions) {
            //Construct adminOptions object

            var deferred = $q.defer();

            //Makes http request
            var request = $http({
                method: 'POST',
                url: '../Synergis.WebApi/api/AdminOptions/SetUploadOptions',
                data: adminOptions,
            }).then(function (response, status, headers, cfg) {
                // All good.
            }, function (err, status) {
                deferred.reject(err);
            });

            return deferred.promise;
        }
    }
})();